import { Helmet } from "react-helmet";

const Disclaimer = () => {
  return (
    <>
        <Helmet>
            <title>Disclaimer | Freelity</title>
            <meta
            name="description"
            content="Disclaimer page of Freelity: Providing free tools and information without any warranty or liability."
            />
            <meta name="robots" content="index, follow" />
            <link rel="canonical" href="https://freelity.com/disclaimer" />
        </Helmet>

        <section className="sec-free-tools termsconditions">
            <div className="container">

                <h1 className="text-center">Disclaimer</h1>
                <p><strong>Last Updated:</strong> May 16, 2025</p>

                <h3>1. General Information</h3>
                <p>
                    Freelity par jo bhi content aur tools diye gaye hain, wo sirf aam maloomat ke liye hain.
                </p>

                <h3>2. No Guarantee</h3>
                <p>
                    Hum ye guarantee nahin dete ke ye content ya tools hamesha sahi, mukammal, ya faida mand rahenge.
                </p>

                <h3>3. No Responsibility</h3>
                <p>
                    Freelity apne tools ya content use karne se hone wale kisi bhi nuksan ya maslay ke liye zimmedar nahin hai.
                </p>

                <h3>4. User Caution</h3>
                <p>
                    Jo bhi user is website ke tools ya maloomat ko use karta hai, wo apni samajh aur ehtiyat se kare.
                </p>

                <h3>5. Acceptance</h3>
                <p>
                    Is website ko use kar ke, user in sharaait ko maan leta hai aur Freelity ki zimmedari ki hadon ko accept karta hai.
                </p>
            </div>
        </section>
        
    </>
  );
};

export default Disclaimer;
